import React from "react";
import { motion } from "framer-motion";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionHeading } from "@/components/sections/SectionHeading";
import { GAME_FEATURES, GAMIFICATION_TIERS } from "@/data/content";

export const Gamification = () => {
  return (
    <section id="gamification" data-testid="gamification" className="relative bg-ivory py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          align="center"
          overline="Stay golden"
          title="Saving that feels like winning"
          accentWord="winning"
          subtitle="Streaks, badges and tiers turn a serious habit into a small daily joy — because wealth should feel rewarding."
        />

        {/* level bar */}
        <Reveal className="mt-16">
          <div className="glass-card rounded-3xl p-8">
            <div className="mb-6 flex items-center justify-between">
              <div>
                <p className="text-xs uppercase tracking-[0.18em] text-charcoal-soft">Current tier</p>
                <p className="font-serif text-2xl text-gold-gradient">Gold · Level 3</p>
              </div>
              <span className="rounded-full bg-gold/12 px-4 py-1.5 text-sm font-semibold text-gold">68% to Platinum</span>
            </div>

            <div className="relative h-3 w-full overflow-hidden rounded-full bg-charcoal/5">
              <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: "68%" }}
                viewport={{ once: true }}
                transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                className="h-full rounded-full bg-gradient-to-r from-gold via-gold-amber to-gold-rose"
              />
            </div>

            <div className="mt-4 grid grid-cols-4 gap-2">
              {GAMIFICATION_TIERS.map((t) => (
                <div key={t.name} className="flex flex-col items-center text-center">
                  <span className="h-3 w-3 rounded-full" style={{ background: t.color }} />
                  <span className="mt-1.5 text-sm font-semibold text-charcoal">{t.name}</span>
                  <span className="text-[11px] text-charcoal-soft">{t.pct}</span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>

        <StaggerGroup className="mt-8 grid gap-6 md:grid-cols-3" stagger={0.1}>
          {GAME_FEATURES.map((f) => (
            <StaggerItem key={f.title}>
              <div className="glass-card group flex h-full items-start gap-4 rounded-3xl p-7 transition-all duration-300 hover:-translate-y-1">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-gold/15 to-gold-rose/20">
                  <f.icon className="h-6 w-6 text-gold" strokeWidth={1.8} />
                </span>
                <div>
                  <h3 className="font-serif text-xl font-normal text-charcoal">{f.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-charcoal-soft">{f.body}</p>
                </div>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
